import { Map } from 'immutable';
import snakeCase from 'lodash/snakeCase';

import { ReviewState, RecieverShareSetting } from 'Shared/types/Review.type';
import { QuestionTypeType } from 'Shared/types/ReviewFormTemplate.type';

import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';

export const getFormTemplateForForm = ({ review, templateFormType }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return ReviewsHelpers.getReviewTemplateReviewForms(review).find(
    template => template.get('formType') === templateFormType
  );
};

export const isReviewComplete = ({ review }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return ReviewsHelpers.getState(review) === ReviewState.COMPLETED;
};

// Sometimes the header is set to the empty string
// In this case we can derive the header from other question properties
export const generateHeaderForQuestion = ({ question, receiverName = null, reviewFormTemplates = [] }) => {
  const questionSanitized = Map.isMap(question) ? question.toJS() : question;

  if (questionSanitized.header) return questionSanitized.header;

  // If no header given and a summarizedQuestionKey exists then use the header for that question
  if (questionSanitized.summarizedQuestionKey) {
    const questions = reviewFormTemplates.map(({ questions }) => questions).flat();
    const summarizedQuestion = questions.find(({ key }) => key === questionSanitized.summarizedQuestionKey);
    if (summarizedQuestion && summarizedQuestion.key !== questionSanitized.key)
      return generateHeaderForQuestion({ question: summarizedQuestion, receiverName, reviewFormTemplates });
  }

  // If no header given then use the property
  if (questionSanitized.type === QuestionTypeType.ADJECTIVES_FOR_PROPERTY) return questionSanitized.property || '';

  // If no header given then use this default
  if (questionSanitized.type === QuestionTypeType.GIF) return 'Gif that represents this person';

  return '';
};

export const convertAnswersToSnakeCase = object => {
  const answersJs = Map.isMap(object) ? object.toJS() : object;
  let answerObject = {};
  Object.keys(answersJs).forEach(key => {
    const value = answersJs[key];
    const valueIsObject = value?.constructor?.name === 'Object';
    let snakeCasedKey = snakeCase(key);
    if (key.startsWith('question') && key.length === 18) {
      const questionSuffix = key.substring(8);
      snakeCasedKey = 'question_' + questionSuffix.toLowerCase();
    }
    answerObject = { ...answerObject, [snakeCasedKey]: valueIsObject ? convertAnswersToSnakeCase(value) : value };
  });
  return answerObject;
};

export const isCurrentUserCreator = ({ review, currentUserSlug }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return ReviewsHelpers.getCreatorSlug(review) === currentUserSlug;
};

export const isCurrentUserCompiler = ({ review, currentUserSlug }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return ReviewsHelpers.getCompilerSlug(review) === currentUserSlug;
};

export const isCurrentUserReceiver = ({ review, currentUserSlug }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return ReviewsHelpers.getReceiverSlug(review) === currentUserSlug;
};

export const isFeedbackSharedAnonymously = ({ review }) => {
  if (!Map.isMap(review)) {
    return false;
  }
  return (
    ReviewsHelpers.getPeerReviewRecipientSharingSetting(review) === RecieverShareSetting.anonymized_peer_reviews_shared
  );
};
